export default __webpack_public_path__ + "static/media/filter.73ca0334.svg";